<template>
  <div>
    <div class="card shadow px-0">
      <div class="card-header bg-transparent">
        <div>
            <div class="col-2">
              <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
            </div>
          <h2 class="mb-0">
            {{ $tc("message.generalConsultations", 1) }}
          </h2>
        </div>
      </div>

      <div class="card-body px-1">
        <b-tabs v-if="!mobileView" card content-class="mt-3" fill active-nav-item-class="font-weight-bold text-uppercase text-success">
          <b-tab no-body :title="$t('message.infoConsultation')">
            <b-row>
              <b-col col sm="8" class="px-0">
                <div class="list-group">
                  <div class="border-bottom">
                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $t("message.institutionConsultation") }}
                        </h4>
                        <span class="font-weight-bold">
                          <p class="consultation-item__body">
                            {{ etablissement }}
                          </p>
                        </span>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $tc("message.practitioners", 1) }}
                        </h4>
                        <span class="font-weight-bold">
                          <p class="consultation-item__body">{{ praticien }}</p>
                        </span>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3" v-if="contributeurs.length > 0">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $tc("message.contributors", 2) }}
                        </h4>
                        <span class="font-weight-bold" v-for="contributeur in contributeurs" :key="contributeur.id">
                          <p class="consultation-item__body">
                            {{ contributeur.nom }}
                          </p>
                        </span>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $t("message.consultationDate") }}
                        </h4>

                        <p class="consultation-item__body">
                          {{ formattedDate(mConsultation.date_consultation) }}
                        </p>
                      </div>
                    </b-col>
                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $tc("message.reasons", 1) }}
                        </h4>
                        <p class="consultation-item__body">{{ reasons }}</p>
                      </div>
                    </b-col>
                  </div>
                  <div class="border-bottom mb-1 py-2">
                    <div class="mb-3">
                      <b-col col sm="12" class="mb-3">
                        <h4 class="consultation-item__title">
                          {{ $t("message.lifestyle") }}
                        </h4>
                        <b-table v-if="!mobileView" striped hover :items="modeDeVie"></b-table>
                        <div v-if="mobileView">
                          <div class="list-group-item">
                            <p class="ligne"><span class="consultation-item__title">family situation</span>: <span
                                class="consultation-item__body">{{this.generalConsultation.situation_familiale}}</span>
                            </p>
                          </div>
                          <div class="list-group-item">
                            <p class="ligne"><span class="consultation-item__title">profession</span>: <span
                                class="consultation-item__body">{{this.generalConsultation.profession}}</span></p>
                          </div>
                          <div class="list-group-item">
                            <p class="ligne"><span class="consultation-item__title">enfants</span>: <span
                                class="consultation-item__body">{{this.generalConsultation.nbre_enfant}}</span></p>
                          </div>
                          <div class="list-group-item">
                            <p class="ligne"><span class="consultation-item__title">tabac</span>: <span
                                class="consultation-item__body">{{this.generalConsultation.tabac}}</span></p>
                          </div>
                          <div class="list-group-item">
                            <p class="ligne"><span class="consultation-item__title">alcool</span>: <span
                                class="consultation-item__body">{{this.generalConsultation.alcool}}</span></p>
                          </div>
                        </div>
                        <h4 class="consultation-item__title">
                          {{ $t("message.autres") }}
                        </h4>
                        <div v-html="this.generalConsultation.autres"></div>
                      </b-col>
                    </div>
                  </div>
                  <!--                                    //Diagnostic-->

                  <b-row class="mx-0">
                    <b-col col sm="12" class="mb-3">
                      <h4 class="consultation-item__title">
                        {{ $t("message.currentTreatments") }}
                      </h4>
                      <div class="" v-if="traitementsRows">
                        <div>
                          <p class="consultation-item__body" v-html="lastTraitment"></p>
                        </div>
                      </div>
                    </b-col>
                    <b-col col sm="12" class="mr-3 mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $t("message.suggestTreatment") }}
                        </h4>
                        <p class="consultation-item__body" v-html="mConsultation.traitement_propose"></p>
                      </div>
                    </b-col>

                    <b-col col sm="12" v-if="mConsultation.rdv">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $t("message.appointmentDate") }}
                        </h4>

                        <p class="consultation-item__body" v-html="mConsultation.rdv.date"></p>
                      </div>
                    </b-col>
                    <b-col col sm="12" v-if="mConsultation.rdv">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $t("message.appointmentReason") }}
                        </h4>

                        <p class="consultation-item__body" v-html="mConsultation.rdv.motifs"></p>
                      </div>
                    </b-col>

                    <b-col col sm="12" v-if="mConsultation.rdv">
                      <div class="">
                        <h4 class="consultation-item__title">
                          {{ $t("message.doctorName") }}
                        </h4>

                        <p class="consultation-item__body" v-if="mConsultation.rdv.praticien != null" v-html="
                            `${
                              mConsultation.rdv.praticien.prenom
                            } ${mConsultation.rdv.praticien.nom.toUpperCase()} `
                          "></p>
                        <p class="consultation-item__body" v-else v-html="mConsultation.rdv.nom_medecin"></p>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col col sm="4">
                <b-row class="justify-content-sm-center">
                  <div class="card-footer text-right">
                    <div v-if="!hasGestionnaireRole" @click="ImprimerConsultation" class="custom-print-wrapper">
                      <button class="custom-print-button">
                        <span class="custom-print-icon"></span>
                      </button>
                      <p class="custom-print-label">
                        {{ $t("message.print") }}
                        {{ $tc("message.consultations", 1) }}
                      </p>
                    </div>
                    <br />
                    <b-button variant="primary" @click="updateConsultation" v-if="canUpdate">
                      {{ $t("message.edit") }}
                    </b-button>
                    <br>
                    <br>

                    <b-button variant="success" @click="archieveConsultation"
                      v-if="!isTransmitted(mConsultation.passed_at) && isArchived(mConsultation.archieved_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)">
                      {{ $t('message.archieve') }}
                    </b-button>
                    <br>
                    <b-button variant="info" @click="transmitConsultation"
                      v-if="isTransmitted(mConsultation.passed_at) && mConsultation.isAuthor && (hasPraticienRole || hasAdminRole || hasMedecinControleRole || hasAssistante)">
                      {{ $t('message.transmit') }}
                    </b-button>
                    <br />
                    <br />

                    <b-button variant="info" @click="reactiveConsultation" v-if="canReactive">
                      {{ $t("message.reavivate") }}
                      {{ $tc("message.consultations", 1) }}
                    </b-button>
                    <br />
                    <br />

                    <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                      {{ $t("message.delete") }}
                    </b-button>
                    <br />
                    <p v-if="errorshasField('nonTransmis')" style="color:red" class="justify-content-sm-center">
                      {{ getErrorsField("nonTransmis") }}
                    </p>
                  </div>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col col sm="12">
                <h4 v-if="isDefine">Fichier joint </h4>
                <img :src="image" class="card-img-top" alt="Image does not show" style="width: 250px; height: auto"
                  v-if="isImage && isDefine">
                <span v-else-if="isDefine && !isImage && image.length >0"><a :href="image" download> Download file
                  </a></span>
                <div v-if="files.length>0">
                  <div v-for="file in files" :key="file.id">
                    <b-row>
                      <b-col col sm="6">
                        <p class="mb-3">{{ file.nom }}</p>
                      </b-col>
                      <b-col col sm="6">
                        <button type="button" class=" ml-5 btn btn-success btn-sm" @click="openFile(file)">
                          Afficher
                        </button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body title="Anamneses">
            <b-container class="bv-example-row">
              <!-- <b-row v-html="mConsultation.anamese"></b-row> -->
              <b-row>
                <div v-for="(c,key) in anamneses" :key="key" class="col-lg-4 mt-4">
                  <h4 class="text-danger">{{key}}</h4>
                  <b-table striped hover :items="anamneses"></b-table>
                  <div :label="key" class="">
                    <div v-for="(item, index) in c" :key="index">
                      <span>{{item.fr_description}}</span>
                    </div>
                  </div>
                </div>
              </b-row>
              <div class="mt-5">
                <editor v-if="mConsultation.anamese" :api-key="tinyKey" initialValue="" v-model="mConsultation.anamese"
                  :init="{
                  height: 650,
                  width: 950,
                  menubar: false,
                  plugins: plugins,
                  toolbar: toolbar,
                }" disabled>
                </editor>
              </div>
              <b-row>
                <div v-for="(c, key) in anamneses" :key="key" class="col-lg-4 mt-4">
                  <h4 class="text-danger">{{ key }}</h4>
                  <b-table striped hover :items="anamneses"></b-table>
                  <div :label="key" class="">
                    <div v-for="(item, index) in c" :key="index">
                      <span>{{ item.fr_description }}</span>
                    </div>
                  </div>
                </div>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab no-body :title="$t('message.parameter')" :active="pathHas('parametreCommun')">
            <b-col sm="12">
              <div class="list-group list-group-flush" id="parametreCommun">
                <b-link class="ml-4" @click="toAddCommonParameter" variant="primary"
                  v-if="(hasAdminRole) || ( (hasPraticienRole || hasMedecinControleRole || hasAssistante) && commonParametersRows.length==0 && isAuthor)">
                  <i class="fas fa-plus-circle edit-icon"></i>
                  {{ $t("message.parameter") }}
                </b-link>

                <div>
                  <b-row>
                    <b-col>
                      <h3 class="mt-3">Glucide</h3>
                      <b-row v-for="(c, key) in glucydes" :key="key">
                        <b-col class="col-sm-8">
                          {{ getTranslate(key) }}
                        </b-col>
                        <b-col> {{ c }} </b-col>
                      </b-row>
                    </b-col>
                    <b-col>
                      <h3>Lipides</h3>
                      <b-row v-for="(c, key) in lipides" :key="key">
                        <b-col class="col-sm-8">
                          {{ getTranslate(key) }}
                        </b-col>
                        <b-col> {{ c }}</b-col>
                      </b-row>
                    </b-col>
                    <b-col>
                      <h3>Nutrition</h3>
                      <b-row v-for="(c, key) in nutritions" :key="key">
                        <b-col> {{ getTranslate(key) }}: </b-col>
                        <b-col :variant="c === 'true' ? 'success' : 'danger'">{{ getVerification(c) }}</b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <vue-good-table class="mt-5" v-if="commonParametersRows && !mobileView"
                    :columns="commonParametersColumns" :rows="commonParametersRows" :search-options="enabled"
                    :pagination-options="paginationOptions" @on-row-click="commonParametersRowClick" />
                  <div v-if="mobileView">
                    <div v-for="(elements, index) in commonParametersRows" :key="index"
                      @click="commonParametersRowClick">
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">TA Systolique (mmHg)</span>: <span
                            class="consultation-item__body">{{elements.taSystolique}}</span></p>
                      </div>
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">TA Diastolique (mmHg)</span>: <span
                            class="consultation-item__body">{{elements.taDiastolique}}</span></p>
                      </div>
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">Poids (Kg)</span>: <span
                            class="consultation-item__body">{{elements.poids}}</span></p>
                      </div>
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">Taille (cm)</span>: <span
                            class="consultation-item__body">{{elements.taille}}</span></p>
                      </div>
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">Temperature (°C)</span>: <span
                            class="consultation-item__body">{{elements.temperature}}</span></p>
                      </div>
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">Bmi (kg/m²)</span>: <span
                            class="consultation-item__body">{{elements.bmi}}</span></p>
                      </div>
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">Frequence respiratoire (cpm)</span>: <span
                            class="consultation-item__body">{{elements.frequence_respiratoire}}</span></p>
                      </div>
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">Frequence cardiaque (bpm)</span>: <span
                            class="consultation-item__body">{{elements.frequence_cardiaque}}</span></p>
                      </div>
                      <div class="list-group-item">
                        <p class="ligne"><span class="new-title">Sato2 (%)</span>: <span
                            class="consultation-item__body">{{elements.sato2}}</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-tab>
          <b-tab no-body :title="$t('message.conclusion')">
            <b-col sm="12">
              <div class="row">
                <div class="mt-2 col-lg-3">
                  <b>ICD Codes</b>
                </div>
                <div class="mt-2 col-lg-9">
                  <b>Terminologies</b>
                </div>
              </div>
              <hr />
              <div v-for="(chose, key) in diagnotics" :key="key" class="text-left row appointment-item">
                <div class="mt-2 col-lg-3">
                  {{ chose.code }}
                </div>
                <hr />
                <div class="mt-2 col-lg-9">
                  {{ chose.bestMatchText }}
                </div>
              </div>
              <b-col col sm="12" class="mb-3">
                <div class="">
                  <h4 class="consultation-item__title">
                    {{ $t('message.diagnostic_complementaire') }}
                  </h4>
                  <p class="consultation-item__body" v-html="this.generalConsultation.diagnostic_complementaire"></p>
                </div>
              </b-col>
              <b-row class="mb-3">
                <b-col col sm="12">
                  <div>
                    <div class="font-weight-bold" v-if="conclusionsRows.length > 0">
                      <div v-for="conclusion in conclusionsRows" :key="conclusion.slug">
                        <p class="consultation-item__body" v-html="conclusion.description"></p>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-tab>
          <b-tab :title="$t('message.examenclinique')">
            <b-container class="bv-example-row mb-2">
              <div class="content" style=" box-shadow:none;">
                <b-row v-if="mConsultation.examen_clinique">
                  <editor :api-key="tinyKey" initialValue="" v-model="mConsultation.examen_clinique" :init="{
                      height: 500,
                      width: 800,
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                    }" disabled>
                  </editor>
                </b-row>
              </div>
              <b-row>
                <div v-for="(c, key) in examens" :key="key" class="col-lg-4 mt-4">
                  <h4 class="text-danger">{{ key }}</h4>
                  <div :label="key" class="">
                    <div v-for="(item, index) in c" :key="index">
                      <span>{{ item.fr_description }}</span>
                    </div>
                  </div>
                </div>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab :title="$t('message.examencomplementaire')" :active="activeTab == 'examen'">
            <b-container class="bv-example-row mb-2 exams_mobile">
              <div class="content" style=" box-shadow:none;">
                <b-row v-if="mConsultation.examen_comp">
                  <editor :api-key="tinyKey" initialValue="" v-model="mConsultation.examen_comp" :init="{
                      height: 500,
                      width: 800,
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                    }" disabled>
                  </editor>
                </b-row>
              </div>
              <b-row>
                <div v-for="(map, key) in complementaire" :key="key+'complementaire'" class="col-lg-6 mt-4">
                  <div class="">
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <h4 class="text-danger">{{ key }}</h4>
                      <div :label="key+'complementaire'" class="">
                        <b-form-checkbox-group v-if="hasMedecinControleRole" name="exams_validate"
                          v-model="exams_validate" text-field="description" :aria-describedby="ariaDescribedby" switches
                          stacked>
                          <b-form-checkbox switch class="mr-n2" v-for="(item, index) in map" :key="index"
                            :value="item.id" :unchecked-value="null">
                            <span class="mr-3">{{ item.description }} </span>
                            <span class="text-danger" v-if="!hasSouscripteurRole"> {{ item.prix }} FCFA</span>
                          </b-form-checkbox>

                        </b-form-checkbox-group>
                        <b-form-checkbox-group v-else name="exams_validate" v-model="exams_validate"
                          text-field="description" :aria-describedby="ariaDescribedby" switches stacked>
                          <b-form-checkbox disabled class="mr-n2" v-for="(item, index) in map" :key="index"
                            :value="item.id">
                            {{ item.description }}
                          </b-form-checkbox>
                        </b-form-checkbox-group>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </b-row>
              <b-row class="justify-content-sm-center" v-if="hasMedecinControleRole">
                <b-button @click="onSubmit" variant="primary">
                  {{ $t('message.save') }} <span class="text-danger" v-if="hasSouscripteurRole"> {{ prixTotal }}
                    FCFA</span>
                </b-button>
              </b-row>

            </b-container>
          </b-tab>
          <b-tab no-body :title="$t('message.currentTreatments')" :active="pathHas('traitement')">
            <b-col sm="12">
              <div class="list-group list-group-flush" id="traitement">
                <b-link class="ml-4" @click="toCurrentTraitement" variant="primary"
                  v-if="(hasAdminRole) || ((hasPraticienRole || hasMedecinControleRole || hasAssistante) && isAuthor)">
                  <i class="fas fa-plus-circle edit-icon"></i>
                  {{ $t("message.currentTreatments") }}
                </b-link>

                <b-card-body>
                  <vue-good-table v-if="traitementsRows" :columns="traitementsColumns" :rows="traitementsRows"
                    :search-options="enabled" :pagination-options="paginationOptions"
                    @on-row-click="onTraitementRowClick" />
                </b-card-body>
              </div>
            </b-col>
          </b-tab>
          <b-tab no-body :title="$t('message.infoAllergies')">
            <b-col sm="12">
              <div class="list-group list-group-flush" id="allergie">
                <b-link class="ml-4" variant="primary" @click="toAllergie"
                  v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                  <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
                </b-link>

                <b-card-body>
                  <vue-good-table v-if="notEmpty(allergiesRows)" :columns="allergiesColumns" :rows="allergiesRows"
                    :search-options="enabled" :pagination-options="paginationOptions"
                    @on-row-click="onAllergieRowClick" />
                </b-card-body>
              </div>
            </b-col>
          </b-tab>
          <b-tab no-body :title="$t('message.infosupplementaire')">
            <b-col sm="12">
              <b-col col sm="12" class="mb-3">
                <div class="">
                  <h4 class="consultation-item__title">
                    {{ $tc("message.infosupplementaire") }}
                  </h4>
                  <span class="font-weight-bold">
                    <p class="consultation-item__body" v-html="infosupplementaire">
                    </p>
                  </span>
                </div>
              </b-col>
            </b-col>
          </b-tab>
          <b-tab no-body :title="$t('message.infoAntecedents')">
            <b-col sm="12">
              <div class="list-group list-group-flush" id="antecedent">
                <b-link class="ml-4" variant="primary" @click="toAntecedent"
                  v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                  <i class="fas fa-plus-circle edit-icon"></i>
                  {{ $t("message.add") }} {{ $tc("message.antecedents", 1) }}
                </b-link>

                <b-card-body>
                  <vue-good-table v-if="notEmpty(antecedentsRows)" :columns="antecedentsColumns" :rows="antecedentsRows"
                    :search-options="enabled" :pagination-options="paginationOptions"
                    @on-row-click="onAntecedentRowClick" />
                </b-card-body>
              </div>
            </b-col>
          </b-tab>
        </b-tabs>

        <!-- affichage mobile -->

        <b-row v-if="mobileView">
          <div class="medicalUl d-medicalUl w-100">
            
              <div class="mobileDropdown d-shadow shadow w-100" @click="dropHidden= !dropHidden">
              
                <h5 class="font-weight-bold d-h d-flex align-items-center w-100 m-0">
                  <b-tabs v-if="mobileView" card content-class="" fill class="w-100 h-100"
                    active-nav-item-class="font-weight-bold text-uppercase text-success" @click="dropHidden= !dropHidden">

                    <b-tab no-body :title="$t('message.infoConsultation')" v-if="infoConsultation" class="py-0"></b-tab>
                    <b-tab no-body title="Anamneses" v-if="Anamneses" class="py-0"></b-tab>
                    <b-tab no-body :title="$t('message.parameter')" :active="pathHas('parametreCommun')" 
                    v-if="parameter"></b-tab>
                    <b-tab no-body :title="$t('message.conclusion')" v-if="conclusion" class="py-0"></b-tab>
                    <b-tab :title="$t('message.examenclinique')" v-if="examenclinique " class="py-0"></b-tab>
                    <b-tab :title="$t('message.examencomplementaire')" :active="activeTab == 'examen'" 
                    v-if="examencomplementaire" class="py-0"></b-tab>
                    <b-tab no-body :title="$t('message.currentTreatments')" :active="pathHas('traitement')" 
                    v-if="currentTreatments" class="py-0"></b-tab>
                    <b-tab no-body :title="$t('message.infoAllergies')" v-if="infoAllergies" class="py-0"></b-tab>
                    <b-tab no-body :title="$t('message.infoAntecedents')" v-if="infoAntecedents" class="py-0"></b-tab>

                  </b-tabs>
                  <span class="fas text-success">&#xf106;</span>
                </h5>
                <div class="text-left" id="myDropdown" v-if="!dropHidden">

                  <b-tabs v-if="mobileView" card content-class="mt-3" fill
                    active-nav-item-class="font-weight-bold text-uppercase text-success">
                    <b-tab no-body :title="$t('message.infoConsultation')" @click="infoConsultation =true, conclusion = false, 
                    infoAllergies =false,  infoAntecedents = false, examencomplementaire = false, examenclinique = false,
                      currentTreatments=false, parameter = false, Anamneses = false, closeDrop()">
                    </b-tab>

                    <b-tab no-body title="Anamneses" @click="Anamneses = true, infoAllergies =false,  infoAntecedents = false, examencomplementaire = false, examenclinique = false,
                      currentTreatments=false, parameter = false, infoConsultation=false, closeDrop()">
                    
                    </b-tab>
                    <b-tab no-body :title="$t('message.parameter')" :active="pathHas('parametreCommun')" @click="parameter = true, 
                    infoAllergies =false,  infoAntecedents = false, examencomplementaire = false, examenclinique = false,
                      currentTreatments=false, conclusion = false, Anamneses = false, infoConsultation=false, closeDrop()">
                      
                    </b-tab>
                    <b-tab no-body :title="$t('message.conclusion')" @click="conclusion = true, 
                    infoAllergies =false,  infoAntecedents = false, examencomplementaire = false, examenclinique = false,
                      currentTreatments=false, parameter = false, Anamneses = false, infoConsultation=false, closeDrop()">
                      
                    </b-tab>
                    <b-tab :title="$t('message.examenclinique')" @click="examenclinique = true, 
                      infoAllergies =false,  infoAntecedents = false, currentTreatments=false, examencomplementaire = false,
                      conclusion = false, parameter = false, Anamneses = false, infoConsultation=false, closeDrop()">
                    </b-tab>
                    <b-tab :title="$t('message.examencomplementaire')" :active="activeTab === 'examen'" @click="examencomplementaire = true, 
                      infoAllergies =false,  infoAntecedents = false, currentTreatments=false, examenclinique = false,
                      conclusion = false, parameter = false, Anamneses = false, infoConsultation=false, closeDrop()">
                    </b-tab>
                    <b-tab no-body :title="$t('message.currentTreatments')" :active="pathHas('traitement')" @click="currentTreatments=true, 
                      infoAllergies =false,  infoAntecedents = false, examencomplementaire = false, examenclinique = false,
                      conclusion = false, parameter = false, Anamneses = false, infoConsultation=false, closeDrop()"></b-tab>
                    <b-tab no-body :title="$t('message.infoAllergies')" @click="infoAllergies = true, 
                      infoAntecedents = false, currentTreatments=false, examencomplementaire = false, examenclinique = false,
                      conclusion = false, parameter = false, Anamneses = false, infoConsultation=false, closeDrop()"></b-tab>
                    <b-tab no-body :title="$t('message.infoAntecedents')" @click="infoAntecedents = true, 
                      infoAllergies = false, currentTreatments=false, examencomplementaire = false, examenclinique = false,
                      conclusion = false, parameter = false, Anamneses = false, infoConsultation=false, closeDrop()"></b-tab>
                  </b-tabs>
                </div>
              </div>
            
          </div>

            <!-- affichage mobile contenu -->
            <div class="w-100">
                <b-tabs card content-class="mt-3" fill active-nav-item-class="font-weight-bold text-uppercase text-success">
                    
                    <div class="mobilec" v-if="infoConsultation">
                          <b-row>
                            <b-col col sm="8" class="px-0">
                              <div class="list-group">
                                <b-row class="border-bottom">
                                  <b-col col sm="12" class="mb-3">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $t("message.institutionConsultation") }}
                                      </h4>
                                      <span class="font-weight-bold">
                                        <p class="consultation-item__body">
                                          {{ etablissement }}
                                        </p>
                                      </span>
                                    </div>
                                  </b-col>

                                  <b-col col sm="12" class="mb-3">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $tc("message.practitioners", 1) }}
                                      </h4>
                                      <span class="font-weight-bold">
                                        <p class="consultation-item__body">{{ praticien }}</p>
                                      </span>
                                    </div>
                                  </b-col>

                                  <b-col col sm="12" class="mb-3" v-if="contributeurs.length > 0">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $tc("message.contributors", 2) }}
                                      </h4>
                                      <span class="font-weight-bold" v-for="contributeur in contributeurs"
                                        :key="contributeur.id">
                                        <p class="consultation-item__body">
                                          {{ contributeur.nom }}
                                        </p>
                                      </span>
                                    </div>
                                  </b-col>

                                  <b-col col sm="12" class="mb-3">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $t("message.consultationDate") }}
                                      </h4>

                                      <p class="consultation-item__body">
                                        {{ formattedDate(mConsultation.date_consultation) }}
                                      </p>
                                    </div>
                                  </b-col>
                                  <b-col col sm="12" class="mb-3">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $tc("message.reasons", 1) }}
                                      </h4>
                                      <p class="consultation-item__body">{{ reasons }}</p>
                                    </div>
                                  </b-col>
                                </b-row>
                                <div class="border-bottom mb-1 py-2">
                                  <div class="mb-3">
                                    <b-col col sm="12" class="mb-3">
                                      <h4 class="consultation-item__title">
                                        {{ $t("message.lifestyle") }}
                                      </h4>
                                      <b-table v-if="!mobileView" striped hover :items="modeDeVie"></b-table>
                                      <div v-if="mobileView">
                                        <div class="list-group-item">
                                          <p class="ligne"><span class="consultation-item__title">family situation</span>:
                                            <span
                                              class="consultation-item__body">{{this.generalConsultation.situation_familiale}}</span>
                                          </p>
                                        </div>
                                        <div class="list-group-item">
                                          <p class="ligne"><span class="consultation-item__title">profession</span>: <span
                                              class="consultation-item__body">{{this.generalConsultation.profession}}</span>
                                          </p>
                                        </div>
                                        <div class="list-group-item">
                                          <p class="ligne"><span class="consultation-item__title">enfants</span>: <span
                                              class="consultation-item__body">{{this.generalConsultation.nbre_enfant}}</span>
                                          </p>
                                        </div>
                                        <div class="list-group-item">
                                          <p class="ligne"><span class="consultation-item__title">tabac</span>: <span
                                              class="consultation-item__body">{{this.generalConsultation.tabac}}</span></p>
                                        </div>
                                        <div class="list-group-item">
                                          <p class="ligne"><span class="consultation-item__title">alcool</span>: <span
                                              class="consultation-item__body">{{this.generalConsultation.alcool}}</span></p>
                                        </div>
                                      </div>
                                      <h4 class="consultation-item__title">
                                        {{ $t("message.autres") }}
                                      </h4>
                                      <div v-html="this.generalConsultation.autres"></div>
                                    </b-col>
                                  </div>
                                </div>
                                <b-row class="mx-0">
                                  <b-col col sm="12" class="mb-3">
                                    <h4 class="consultation-item__title">
                                      {{ $t("message.currentTreatments") }}
                                    </h4>
                                    <div class="" v-if="traitementsRows">
                                      <div>
                                        <p class="consultation-item__body" v-html="lastTraitment"></p>
                                      </div>
                                    </div>
                                  </b-col>
                                  <b-col col sm="12" class="mr-3 mb-3">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $t("message.suggestTreatment") }}
                                      </h4>
                                      <p class="consultation-item__body" v-html="mConsultation.traitement_propose"></p>
                                    </div>
                                  </b-col>

                                  <b-col col sm="12" v-if="mConsultation.rdv">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $t("message.appointmentDate") }}
                                      </h4>

                                      <p class="consultation-item__body" v-html="mConsultation.rdv.date"></p>
                                    </div>
                                  </b-col>
                                  <b-col col sm="12" v-if="mConsultation.rdv">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $t("message.appointmentReason") }}
                                      </h4>

                                      <p class="consultation-item__body" v-html="mConsultation.rdv.motifs"></p>
                                    </div>
                                  </b-col>

                                  <b-col col sm="12" v-if="mConsultation.rdv">
                                    <div class="">
                                      <h4 class="consultation-item__title">
                                        {{ $t("message.doctorName") }}
                                      </h4>

                                      <p class="consultation-item__body" v-if="mConsultation.rdv.praticien != null" v-html="
                                  `${
                                    mConsultation.rdv.praticien.prenom
                                  } ${mConsultation.rdv.praticien.nom.toUpperCase()} `
                                "></p>
                                      <p class="consultation-item__body" v-else v-html="mConsultation.rdv.nom_medecin"></p>
                                    </div>
                                  </b-col>
                                </b-row>
                              </div>
                            </b-col>
                            <b-col col sm="4">
                              <b-row class="justify-content-sm-center">
                                <div class="card-footer text-right">
                                  <div v-if="!hasGestionnaireRole" @click="ImprimerConsultation" class="custom-print-wrapper">
                                    <button class="custom-print-button">
                                      <span class="custom-print-icon"></span>
                                    </button>
                                    <p class="custom-print-label">
                                      {{ $t("message.print") }}
                                      {{ $tc("message.consultations", 1) }}
                                    </p>
                                  </div>
                                  <br />
                                  <b-button variant="primary" @click="updateConsultation" v-if="canUpdate">
                                    {{ $t("message.edit") }}
                                  </b-button>
                                  <br>
                                  <br>

                                  <b-button variant="success" @click="archieveConsultation"
                                    v-if="!isTransmitted(mConsultation.passed_at) && isArchived(mConsultation.archieved_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)">
                                    {{ $t('message.archieve') }}
                                  </b-button>
                                  <br>
                                  <b-button variant="info" @click="transmitConsultation"
                                    v-if="isTransmitted(mConsultation.passed_at) && mConsultation.isAuthor && (hasPraticienRole || hasAdminRole || hasMedecinControleRole || hasAssistante)">
                                    {{ $t('message.transmit') }}
                                  </b-button>
                                  <br />
                                  <br />

                                  <b-button variant="info" @click="reactiveConsultation" v-if="canReactive">
                                    {{ $t("message.reavivate") }}
                                    {{ $tc("message.consultations", 1) }}
                                  </b-button>
                                  <br />
                                  <br />

                                  <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                                    {{ $t("message.delete") }}
                                  </b-button>
                                  <br />
                                  <p v-if="errorshasField('nonTransmis')" style="color:red" class="justify-content-sm-center">
                                    {{ getErrorsField("nonTransmis") }}
                                  </p>
                                </div>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col col sm="12">
                              <h4 v-if="isDefine">Fichier joint </h4>
                              <img :src="image" class="card-img-top" alt="Image does not show"
                                style="width: 250px; height: auto" v-if="isImage && isDefine">
                              <span v-else-if="isDefine && !isImage && image.length >0"><a :href="image" download> Download
                                  file </a></span>
                              <div v-if="files.length>0">
                                <div v-for="file in files" :key="file.id">
                                  <b-row>
                                    <b-col col sm="6">
                                      <p class="mb-3">{{ file.nom }}</p>
                                    </b-col>
                                    <b-col col sm="6">
                                      <button type="button" class=" ml-5 btn btn-success btn-sm" @click="openFile(file)">
                                        Afficher
                                      </button>
                                    </b-col>
                                  </b-row>
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                      </div>

                     <b-container class="bv-example-row" v-if="Anamneses">
                      <!-- <b-row v-html="mConsultation.anamese"></b-row> -->
                      <b-row>
                        <div v-for="(c,key) in anamneses" :key="key" class="col-lg-4 mt-4">
                          <h4 class="text-danger">{{key}}</h4>
                          <b-table striped hover :items="anamneses"></b-table>
                          <div :label="key" class="">
                            <div v-for="(item, index) in c" :key="index">
                              <span>{{item.fr_description}}</span>
                            </div>
                          </div>
                        </div>
                      </b-row>
                      <div class="mt-5">
                        <editor v-if="mConsultation.anamese" :api-key="tinyKey" initialValue=""
                          v-model="mConsultation.anamese" :init="{
                          height: 650,
                          width: 950,
                          menubar: false,
                          plugins: plugins,
                          toolbar: toolbar,
                        }" disabled>
                        </editor>
                      </div>
                      <b-row>
                        <div v-for="(c, key) in anamneses" :key="key" class="col-lg-4 mt-4">
                          <h4 class="text-danger">{{ key }}</h4>
                          <b-table striped hover :items="anamneses"></b-table>
                          <div :label="key" class="">
                            <div v-for="(item, index) in c" :key="index">
                              <span>{{ item.fr_description }}</span>
                            </div>
                          </div>
                        </div>
                      </b-row>
                    </b-container>

                    <b-col sm="12" v-if="parameter">
                      <div class="list-group list-group-flush" id="parametreCommun">
                        <b-link class="ml-4" @click="toAddCommonParameter" variant="primary"
                          v-if="(hasAdminRole) || ( (hasPraticienRole || hasMedecinControleRole || hasAssistante) && commonParametersRows.length==0 && isAuthor)">
                          <i class="fas fa-plus-circle edit-icon"></i>
                          {{ $t("message.parameter") }}
                        </b-link>

                        <div>
                          <b-row>
                            <b-col>
                              <h3 class="mt-3">Glucide</h3>
                              <b-row v-for="(c, key) in glucydes" :key="key">
                                <b-col class="col-sm-8">
                                  {{ getTranslate(key) }}
                                </b-col>
                                <b-col> {{ c }} </b-col>
                              </b-row>
                            </b-col>
                            <b-col>
                              <h3>Lipides</h3>
                              <b-row v-for="(c, key) in lipides" :key="key">
                                <b-col class="col-sm-8">
                                  {{ getTranslate(key) }}
                                </b-col>
                                <b-col> {{ c }}</b-col>
                              </b-row>
                            </b-col>
                            <b-col>
                              <h3>Nutrition</h3>
                              <b-row v-for="(c, key) in nutritions" :key="key">
                                <b-col> {{ getTranslate(key) }}: </b-col>
                                <b-col :variant="c === 'true' ? 'success' : 'danger'">{{ getVerification(c) }}</b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <vue-good-table class="mt-5" v-if="commonParametersRows && !mobileView"
                            :columns="commonParametersColumns" :rows="commonParametersRows" :search-options="enabled"
                            :pagination-options="paginationOptions" @on-row-click="commonParametersRowClick" />
                          <div v-if="mobileView">
                            <div v-for="(elements, index) in commonParametersRows" :key="index"
                              @click="commonParametersRowClick">
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">TA Systolique (mmHg)</span>: <span
                                    class="consultation-item__body">{{elements.taSystolique}}</span></p>
                              </div>
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">TA Diastolique (mmHg)</span>: <span
                                    class="consultation-item__body">{{elements.taDiastolique}}</span></p>
                              </div>
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">Poids (Kg)</span>: <span
                                    class="consultation-item__body">{{elements.poids}}</span></p>
                              </div>
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">Taille (cm)</span>: <span
                                    class="consultation-item__body">{{elements.taille}}</span></p>
                              </div>
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">Temperature (°C)</span>: <span
                                    class="consultation-item__body">{{elements.temperature}}</span></p>
                              </div>
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">Bmi (kg/m²)</span>: <span
                                    class="consultation-item__body">{{elements.bmi}}</span></p>
                              </div>
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">Frequence respiratoire (cpm)</span>: <span
                                    class="consultation-item__body">{{elements.frequence_respiratoire}}</span></p>
                              </div>
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">Frequence cardiaque (bpm)</span>: <span
                                    class="consultation-item__body">{{elements.frequence_cardiaque}}</span></p>
                              </div>
                              <div class="list-group-item">
                                <p class="ligne"><span class="new-title">Sato2 (%)</span>: <span
                                    class="consultation-item__body">{{elements.sato2}}</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-col>

                    <b-col sm="12" v-if="conclusion">
                      <div class="row">
                        <div class="mt-2 col-lg-3">
                          <b>ICD Codes</b>
                        </div>
                        <div class="mt-2 col-lg-9">
                          <b>Terminologies</b>
                        </div>
                      </div>
                      <hr />
                      <div v-for="(chose, key) in diagnotics" :key="key" class="text-left row appointment-item">
                        <div class="mt-2 col-lg-3">
                          {{ chose.code }}
                        </div>
                        <hr />
                        <div class="mt-2 col-lg-9">
                          {{ chose.bestMatchText }}
                        </div>
                      </div>
                      <b-row class="mb-3">
                        <b-col col sm="12">
                          <div>
                            <div class="font-weight-bold" v-if="conclusionsRows.length > 0">
                              <div v-for="conclusion in conclusionsRows" :key="conclusion.slug">
                                <p class="consultation-item__body" v-html="conclusion.description"></p>
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-container class="bv-example-row mb-2" v-if="examenclinique">
                      <div class="content" style=" box-shadow:none;">
                        <b-row v-if="mConsultation.examen_clinique">
                          <editor :api-key="tinyKey" initialValue="" v-model="mConsultation.examen_clinique" :init="{
                      height: 500,
                      width: 800,
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      }" disabled>
                          </editor>
                        </b-row>
                      </div>
                      <b-row>
                        <div v-for="(c, key) in examens" :key="key" class="col-lg-4 mt-4">
                          <h4 class="text-danger">{{ key }}</h4>
                          <div :label="key" class="">
                            <div v-for="(item, index) in c" :key="index">
                              <span>{{ item.fr_description }}</span>
                            </div>
                          </div>
                        </div>
                      </b-row>
                    </b-container>

                    <b-container class="bv-example-row mb-2 exams_mobile" v-if="examencomplementaire">
                      <div class="content" style=" box-shadow:none;">
                        <b-row v-if="mConsultation.examen_comp">
                          <editor :api-key="tinyKey" initialValue="" v-model="mConsultation.examen_comp" :init="{
                      height: 500,
                      width: 800,
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      }" disabled>
                          </editor>
                        </b-row>
                      </div>
                      <b-row>
                        <div v-for="(map, key) in complementaire" :key="key+'complementaire'" class="col-lg-6 mt-4">
                          <div class="">
                            <b-form-group v-slot="{ ariaDescribedby }">
                              <h4 class="text-danger">{{ key }}</h4>
                              <div :label="key+'complementaire'" class="">
                                <b-form-checkbox-group v-if="hasMedecinControleRole" name="exams_validate"
                                  v-model="exams_validate" text-field="description" :aria-describedby="ariaDescribedby"
                                  switches stacked>
                                  <b-form-checkbox switch class="mr-n2" v-for="(item, index) in map" :key="index"
                                    :value="item.id" :unchecked-value="null">
                                    <span class="mr-3">{{ item.description }} </span>
                                    <span class="text-danger" v-if="!hasSouscripteurRole"> {{ item.prix }} FCFA</span>
                                  </b-form-checkbox>

                                </b-form-checkbox-group>
                                <b-form-checkbox-group v-else name="exams_validate" v-model="exams_validate"
                                  text-field="description" :aria-describedby="ariaDescribedby" switches stacked>
                                  <b-form-checkbox disabled class="mr-n2" v-for="(item, index) in map" :key="index"
                                    :value="item.id">
                                    {{ item.description }}
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                      </b-row>
                      <b-row class="justify-content-sm-center" v-if="hasMedecinControleRole">
                        <b-button @click="onSubmit" variant="primary">
                          {{ $t('message.save') }} <span class="text-danger" v-if="hasSouscripteurRole"> {{ prixTotal }}
                            FCFA</span>
                        </b-button>
                      </b-row>

                    </b-container>
                    
                    <b-col sm="12" v-if="currentTreatments">
                      <div class="list-group list-group-flush" id="traitement">
                        <b-link class="ml-4" @click="toCurrentTraitement" variant="primary"
                          v-if="(hasAdminRole) || ((hasPraticienRole || hasMedecinControleRole || hasAssistante) && isAuthor)">
                          <i class="fas fa-plus-circle edit-icon"></i>
                          {{ $t("message.currentTreatments") }}
                        </b-link>

                        <b-card-body>
                          <vue-good-table v-if="traitementsRows" :columns="traitementsColumns" :rows="traitementsRows"
                            :search-options="enabled" :pagination-options="paginationOptions"
                            @on-row-click="onTraitementRowClick" />
                        </b-card-body>
                      </div>
                    </b-col>
                    
                    <b-col sm="12" v-if="infoAllergies">
                      <div class="list-group list-group-flush" id="allergie">
                        <b-link class="ml-4" variant="primary" @click="toAllergie"
                          v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                          <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
                        </b-link>

                        <b-card-body>
                          <vue-good-table v-if="notEmpty(allergiesRows)" :columns="allergiesColumns"
                            :rows="allergiesRows" :search-options="enabled" :pagination-options="paginationOptions"
                            @on-row-click="onAllergieRowClick" />
                        </b-card-body>
                      </div>
                    </b-col>
                     
                     <b-col sm="12" v-if="infoAntecedents">
                        <div class="list-group list-group-flush" id="antecedent">
                          <b-link class="ml-4" variant="primary" @click="toAntecedent"
                            v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                            <i class="fas fa-plus-circle edit-icon"></i>
                            {{ $t("message.add") }} {{ $tc("message.antecedents", 1) }}
                          </b-link>

                          <b-card-body>
                            <vue-good-table v-if="notEmpty(antecedentsRows)" :columns="antecedentsColumns" :rows="antecedentsRows"
                              :search-options="enabled" :pagination-options="paginationOptions"
                              @on-row-click="onAntecedentRowClick" />
                          </b-card-body>
                        </div>
                      </b-col>
                </b-tabs>            
            </div>                   
        </b-row>


        <div class="card">
          <b-modal id="delete-modal" size="sm" header-bg-variant="danger" header-text-variant="light" :title="
              $t('message.delete') +
                ' ' +
                $tc('message.generalConsultations', 1)
            " hide-footer>
            <div class="d-block text-center">
              <h3>
                {{ $t("message.delete") }}
                {{ formattedDate(mConsultation.date_consultation) }}
              </h3>
            </div>

            <div class="d-block float-right">
              <b-button variant="danger" @click="deleteConsultation">
                {{ $t("message.delete") }}
              </b-button>

              <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                {{ $t("message.cancel") }}
              </b-button>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import $ from "jquery";
import AppConfig from "../../../constants/AppConfig";
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "GeneralMedicine",
  components: {
    editor: Editor,
  },
  computed: {
    ...mapGetters([
      "generalConsultation",
      "validation_prix",
      "errors",
      "hasAdminRole",
      "hasMedecinControleRole",
      "hasSouscripteurRole",
      "hasPatientRole",
      'hasPraticienRole',
      'hasGestionnaireRole','hasAssistante']),

    image: function() {
      if (
        !_.isUndefined(this.mConsultation.file) &&
        !_.isNull(this.mConsultation.file)
      ) {
        if (
          this.mConsultation.file.length > 0 &&
          this.mConsultation.file != "null"
        ) {
          return (
            AppConfig.imgUrl + "/public/storage/" + this.mConsultation.file
          );
        }
        return "";
      }
      return "";
    },

    isDefine: function() {
      return (
        (this.generalConsultation.file != "null" &&
          !_.isNull(this.generalConsultation.file)) ||
        this.files.length > 0
      );
    },

    isImage: function() {
      if (
        this.generalConsultation.file != "null" &&
        !_.isEmpty(this.generalConsultation.file)
      ) {
        return (
          this.generalConsultation.file.includes(".jpeg") ||
          this.generalConsultation.file.includes(".png") ||
          this.generalConsultation.file.includes(".jpg")
        );
      }
      return false;
    },

    mConsultation: function() {
      return this.generalConsultation;
    },

    modeDeVie: function() {
      return [
        {
          "family situation": this.generalConsultation.situation_familiale,
          profession: this.generalConsultation.profession,
          enfants: this.generalConsultation.nbre_enfant,
          tabac: this.generalConsultation.tabac,
          alcool: this.generalConsultation.alcool,
        },
      ];
    },

    contributeurs: function() {
      let cArray = [];
      if (!_.isUndefined(this.generalConsultation)) {
        if (!_.isUndefined(this.generalConsultation.operationables)) {
          _.forEach(this.generalConsultation.operationables, function(
            operation
          ) {
            if (!_.isUndefined(operation.contributable)) {
              let contributable = operation.contributable;
              let prenom = contributable.prenom != "null" ? contributable.prenom : "";
              if(!_.isNull(prenom)){
                prenom = prenom.toLowerCase();
                let nomComplet =
                contributable.nom.toUpperCase() +
                " " +
                prenom.charAt(0).toUpperCase() +
                prenom.substring(1);
              cArray.push({ nom: nomComplet });
              }else {
                let nomComplet =
                contributable.nom.toUpperCase();
              cArray.push({ nom: nomComplet });
              }
            }
          });
        }
      }
      return cArray;
    },

    files: function() {
      return _.isUndefined(this.mConsultation.files)
        ? []
        : this.mConsultation.files;
    },

    isAuthor: function() {
      return this.mConsultation.isAuthor;
    },

    canUpdate: function() {
      return this.mConsultation.canUpdate;
    },

    canReactive:function(){
      return !_.isNull(this.mConsultation.passed_at) && (this.hasAdminRole || this.hasMedecinControleRole || this.hasAssistante);
    },

    canDelete: function() {
      if (this.hasAdminRole) return true;

      return (
        this.mConsultation.canUpdate &&
        _.isNull(this.mConsultation.archieved_at) &&
        _.isNull(this.mConsultation.passed_at)
      );
    },

    etablissement: function() {
      if (!_.isUndefined(this.mConsultation)) {
        if (!_.isUndefined(this.mConsultation.etablissement_id)) {
          if (!_.isNull(this.mConsultation.etablissement_id)) {
            return this.mConsultation.etablissement_id.nom;
          }
          return "";
        }
      }
      return "";
    },

    infosupplementaire: function(){
      if (!_.isUndefined(this.mConsultation)) {
        if (!_.isUndefined(this.mConsultation.information)) {
          return this.mConsultation.information;
        }
      }
      return "";
    },

    praticien: function() {
      let author = this.mConsultation.author;
      if (!_.isNull(author) && !_.isUndefined(author)) {
        if (author.hasOwnProperty("user")) {
          let user = author.user;
          if (!_.isUndefined(user) && !_.isNull(user)) {
            let prenom = user.prenom == null ? "" : user.prenom;
            return (
              user.nom.toUpperCase() +
              " " +
              prenom.charAt(0).toUpperCase() +
              prenom.substring(1)
            );
          }
        } else {
          if (!_.isUndefined(author) && !_.isNull(author)) {
            let prenom = author.prenom == null ? "" : author.prenom;
            return (
              author.nom.toUpperCase() +
              " " +
              prenom.charAt(0).toUpperCase() +
              prenom.substring(1)
            );
          }
        }
      }
      return "";
    },

    nom: function() {
      if (typeof this.generalConsultation.dossier == "object") {
        let user = this.generalConsultation.dossier.patient.user;

        let nom = user.nom;
        let prenom = user.prenom != null ? user.prenom : "";

        return prenom + " " + nom.toUpperCase();
      } else {
        return "";
      }
    },
    examens: function() {
      if (this.generalConsultation.examens === null) {
        return null;
      }
      if (typeof this.generalConsultation.examens === "string") {
        let test = JSON.parse(this.generalConsultation.examens);
        const groups = test.reduce((groups, item) => {
          const group = groups[item.reference] || [];
          group.push(item);
          groups[item.reference] = group;
          return groups;
        }, {});
        return groups;
      } else if (typeof this.generalConsultation.examens === "object") {
        const groups = this.generalConsultation.examens.reduce(
          (groups, item) => {
            const group = groups[item.reference] || [];
            group.push(item);
            groups[item.reference] = group;
            return groups;
          },
          {}
        );
        return groups;
      } else {
        return null;
      }
    },
    complementaire: function() {
      let self = this;
      let groups = [];
        self.exams_validate = self.validation_prix.filter(item => item.etat_validation_medecin == 1).map(examen => examen.id);
      _.forEach(this.validation_prix,function(exam){
        let arr = {};
        arr.etat = exam.etat_validation_medecin,
        arr.date = exam.date_validation_medecin,
        arr.reference = exam.examen_complementaire.reference,
        arr.description = exam.examen_complementaire.fr_description,
        arr.prix = exam.examen_complementaire.examen_complementaire_prix.length > 0 ? exam.examen_complementaire.examen_complementaire_prix[0].prix:0,
        arr.id = exam.id,
        arr.item = exam;
        groups.push(arr);
      })

      return groups.reduce(
          (groups, item) => {
            const group = groups[item.reference] || [];
            group.push(item);
            groups[item.reference] = group;
            return groups;
          },
          {}
        );
    },
    examen_comp: function() {
      if (
        /^[\],:{}\s]*$/.test(
          this.mConsultation.examen_complementaire
            .replace(/\\["\\\/bfnrtu]/g, "@")
            .replace(
              /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
              "]"
            )
            .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
        )
      ) {
        return "";
      }
    },
    anamneses: function() {
      if (this.generalConsultation.anamneses === null) {
        return null;
      }
      if (typeof this.generalConsultation.anamneses === "string") {
        let test = JSON.parse(this.generalConsultation.anamneses);
        const groups = test.reduce((groups, item) => {
          const group = groups[item.reference] || [];
          group.push(item);
          groups[item.reference] = group;
          return groups;
        }, {});
        return groups;
      } else if (typeof this.generalConsultation.anamneses === "object") {
        const groups = this.generalConsultation.anamneses.reduce(
          (groups, item) => {
            const group = groups[item.reference] || [];
            group.push(item);
            groups[item.reference] = group;
            return groups;
          },
          {}
        );
        return groups;
      } else {
        return null;
      }
    },
    glucydes: function() {
      if (typeof this.generalConsultation.glucide === "string") {
        return JSON.parse(this.generalConsultation.glucide);
      } else if (typeof this.generalConsultation.glucide === "object") {
        return this.generalConsultation.glucide;
      } else {
        return null;
      }
    },
    lipides: function() {
      if (typeof this.generalConsultation.lipide === "string") {
        return JSON.parse(this.generalConsultation.lipide);
      } else if (typeof this.generalConsultation.lipide === "object") {
        return this.generalConsultation.lipide;
      } else {
        return null;
      }
    },
    nutritions: function() {
      if (typeof this.generalConsultation.nutrition === "string") {
        return JSON.parse(this.generalConsultation.nutrition);
      } else if (typeof this.generalConsultation.nutrition === "object") {
        return this.generalConsultation.nutrition;
      } else {
        return null;
      }
    },
    diagnotics: function() {
      if (typeof this.generalConsultation.diasgnostic === "string") {
        return JSON.parse(this.generalConsultation.diasgnostic);
      } else if (typeof this.generalConsultation.diasgnostic === "object") {
        return this.generalConsultation.diasgnostic;
      } else {
        return null;
      }
    },
    diagnostic_complementaire(){
      if (typeof this.generalConsultation.diagnostic_complementaire == "string") {
        return JSON.parse(this.generalConsultation.diagnostic_complementaire);
      } else {
        return null;
      }
    },
    reasons: function() {
      console.log("this.mConsultation.current_motifs ", this.mConsultation.current_motifs)
      let motifs = "";
      if (!_.isUndefined(this.mConsultation.current_motifs)) {
        _.forEach(this.mConsultation.current_motifs, function(motif) {
          motifs += motif.description+", ";
        });
        return motifs;
      }

      return "";
    },

    allergiesRows: function() {
      let aArray = [];
      if (!_.isUndefined(this.mConsultation.dossier)) {
        _.forEach(this.mConsultation.dossier.allergies, function(allergy) {
          aArray.push({
            description: allergy.description,
            date: allergy.date,
            slug: allergy.slug,
          });
        });
      }
      return aArray;
    },

    commonParametersRows: function() {
      let cArray = [];
      if (!_.isUndefined(this.mConsultation.parametres_commun)) {
        _.forEach(this.mConsultation.parametres_commun, function(
          parametre_commun
        ) {
          cArray.push({
            taSystolique: parametre_commun.ta_systolique,
            taDiastolique: parametre_commun.ta_diastolique,
            poids: parametre_commun.poids,
            taille: parametre_commun.taille,
            temperature: parametre_commun.temperature,
            bmi: parametre_commun.bmi,
            frequence_respiratoire: parametre_commun.frequence_respiratoire,
            frequence_cardiaque: parametre_commun.frequence_cardiaque,
            sato2: parametre_commun.sato2,
            slug: parametre_commun.slug,
          });
        });
      }
      return cArray;
    },

    antecedentsRows: function() {
      let mArray = [];
      if (!_.isUndefined(this.mConsultation.dossier)) {
        mArray = this.mConsultation.dossier.antecedents;
        let cMedecines = this.mConsultation.dossier.consultations_medecine;
        let cCardiologies = this.mConsultation.dossier.cardiologies;
        
      }
      return mArray;
    },

    traitementsRows: function() {
      let tArray = [];
      if (!_.isUndefined(this.mConsultation.dossier)) {
        _.forEach(this.mConsultation.dossier.traitements, function(traitement) {
          tArray.push({
            description: traitement.description,
            slug: traitement.slug,
          });
          // tArray.push({date:traitement.created_at,description: traitement.description,slug:traitement.slug})
        });
      }
      return tArray;
    },

    conclusionsRows: function() {
      let cArray = [];
      if (!_.isUndefined(this.mConsultation.conclusions)) {
        _.forEach(this.mConsultation.conclusions, function(conclusion) {
          cArray.push({
            reference: conclusion.reference,
            description: conclusion.description,
            slug: conclusion.slug,
          });
        });
      }
      return cArray;
    },

    reasonsRows: function() {
      let mArray = [];
      if (!_.isUndefined(this.mConsultation.motifs)) {
        _.forEach(this.mConsultation.motifs, function(motif) {
          mArray.push({
            reference: motif.reference,
            description: motif.description,
            slug: motif.slug,
          });
        });
      }
      return mArray;
    },

    lastTraitment: function() {
      if (this.traitementsRows.length > 0) {
        if (
          !_.isUndefined(this.traitementsRows[this.traitementsRows.length - 1])
        ) {
          return this.traitementsRows[this.traitementsRows.length - 1]
            .description;
        }
        return "";
      }
      return "";
    },
  },

  data() {
    return {
      mobileView: true,
      dropHidden:true,
      infoAntecedents: false,
      infoAllergies: false,
      currentTreatments: false,
      examencomplementaire: true,
      examenclinique: false,
      conclusion: false,
      parameter: false,
      Anamneses: false,
      infoConsultation: false,
      readonly: true,
      afficher: 0,
      tinyKey: AppConfig.tinyMceKey,
      exams_validate: [],
      prixTotal:0,
      plugins: [
        "advlist autolink lists  image charmap",
        "searchreplace visualblocks code fullscreen",
        "print preview anchor insertdatetime media",
        "paste code help wordcount table",
      ],
      activeTab: this.$route.query.activeTab,
      toolbar: "",
      consultation_id: this.$route.params.consultation,

      commonParametersColumns: [
        {
          label: this.$i18n.t("message.weight"),
          field: "poids",
        },

        {
          label: this.$i18n.t("message.height"),
          field: "taille",
        },

        {
          label: this.$i18n.t("message.bmi"),
          field: "bmi",
        },

        {
          label: this.$i18n.t("message.taSystolique"),
          field: "taSystolique",
        },

        {
          label: this.$i18n.t("message.taDiastolique"),
          field: "taDiastolique",
        },

        {
          label: this.$i18n.t("message.temperature"),
          field: "temperature",
        },

        {
          label: this.$i18n.t("message.heartRate"),
          field: "frequence_cardiaque",
        },

        {
          label: this.$i18n.t("message.respiratoryRate"),
          field: "frequence_respiratoire",
        },
      ],

      traitementsColumns: [
        {
          label: "Description",
          field: "description",
          html: true,
        },
       
      ],

      reasonsColumns: [
        {
          label: this.$i18n.t("message.reference"),
          field: "reference",
        },
        {
          label: this.$i18n.t("message.description"),
          field: "description",
          html: true,
        },
      ],

      conclusionsColumns: [
        {
          label: this.$i18n.t("message.reference"),
          field: "reference",
        },
        {
          label: this.$i18n.t("message.description"),
          field: "description",
          html: true,
        },
      ],

      antecedentsColumns: [
        {
          label: this.$i18n.tc("message.types", 1),
          field: "type",
        },
        {
          label: "Description",
          field: "description",
          html: true,
        },
        {
          label: this.$i18n.t("message.startDate"),
          field: "date",
          type: "date",
          dateInputFormat: "yyyy-mm-dd",
          dateOutputFormat: "dd-mm-yyyy",
        },
      ],

      paginationOptions: {
        enabled: true,
        mode: "records",
        perPageDropdown: [3, 6, 10],
      },

      enabled: { enabled: true },

      sort: {
        enabled: true,
        initialSortBy: { field: "date", type: "desc" },
      },

      allergiesColumns: [
        {
          label: "Description",
          field: "description",
          html: true,
        },
      ],
    };
  },

  methods: {
    closeDrop(){
      // console.log("closeDrop", this.dropHidden);
      this.dropHidden = !this.dropHidden;
    },
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    }, 
    onSubmit: function () {
      let self = this;
      let exams = [];
      _.forEach(this.validation_prix,function(item){
        let arr = {};
        arr.id = item.id
        arr.prix = item.examen_complementaire.examen_complementaire_prix.length > 0 ? item.examen_complementaire.examen_complementaire_prix[0].prix : 0;
        if(self.exams_validate.includes(item.id)){
          arr.etat= 1;
        }else{
          arr.etat= 0;
        }
        exams.push(arr);
      });
      let args = {
        examens:exams,
        consultation_id:this.generalConsultation.id
      };

      let successMessage = this.$i18n.t(
        "message.Examenupdated"
      );
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };
      if(this.hasMedecinControleRole){
        this.$store.dispatch("setEtatValidationExamens", {
          args,
          index: self.consultation_id,
          successMessage,
          errorMessages,
        });
      }else{
        this.$store.dispatch("setEtatValidationExamensSouscripteur", {
          args,
          index: self.consultation_id,
          successMessage,
          errorMessages,
        });  
      }
    },
    openFile(file) {
      window.open(AppConfig.imgUrl + "/public/storage/" + file.chemin);
    },
    ImprimerConsultation() {
      let args = {
        generale: this.consultation_id,
      };
      
      this.$store.dispatch("printConsultationMedecine", { args });
    },

    reasonsRowClick(params) {
      this.$router.push({
        name: "reason",
        params: { reason: params.row.slug },
      });
    },

    allerA(item) {
      return this.$route.path + item;
    },

    conclusionsRowClick(params) {
      this.$router.push({
        name: "conclusion",
        params: { conclusion: params.row.slug },
      });
    },

    commonParametersRowClick(params) {
      this.$router.push({
        name: "parameter-common",
        params: { parameter: params.row.slug },
      });
    },
    onTraitementRowClick(params) {
      this.$router.push({
        name: "treatment",
        params: { treatment: params.row.slug },
      });
    },

    onAntecedentRowClick(params) {
      if (params.row.hasOwnProperty("medecine")) {
        this.$router.push({
          name: "consultation-general",
          params: { consultation: params.row.medecine },
        });
      } else if (params.row.hasOwnProperty("cardiology")) {
        this.$router.push({
          name: "consultation-cardiology",
          params: { consultation: params.row.cardiology },
        });
      } else {
        this.$router.push({
          name: "antecedent",
          params: {
            antecedent: params.row.slug,
            file: this.generalConsultation.dossier.slug,
          },
        });
      }
    },

    onAllergieRowClick(params) {
      this.$router.push({
        name: "allergy",
        params: { allergy: params.row.slug },
      });
    },

    notEmpty(item) {
      if (item) return item.length > 0;

      return false;
    },

    toAllergie() {
      this.$router.push({
        name: "add-allergy",
        params: { file: this.generalConsultation.dossier.slug },
      });
    },

    toCurrentTraitement() {
      this.$router.push({
        name: "add-treatments",
        params: { file: this.generalConsultation.dossier.slug },
      });
    },

    toAddReason() {
      this.$router.push({
        name: "add-consultation-reason",
        params: { consultation: this.consultation_id },
      });
    },

    toAddCommonParameter() {
      this.$router.push({
        name: "add-parameter-common",
        params: { consultation: this.consultation_id },
      });
    },

    toConclusion() {
      this.$router.push({
        name: "conclusions",
        params: { consultation: this.consultation_id },
      });
    },

    toAntecedent() {
      this.$router.push({
        name: "add-antecedent",
        params: { file: this.generalConsultation.dossier.slug },
      });
    },

    getConsultation() {
      let args = {
        consultation: this.consultation_id,
      };

      this.$store.dispatch("getGeneralConsultation", { args });
    },
    examenComplementaire() {
      let args = {
        consultation: this.consultation_id,
      };

      this.$store.dispatch("getExamenComplementaireValidation", { args });
    },
    formattedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    updateConsultation() {
      localStorage.setItem("reload", 0);
      localStorage.setItem("dossier_medical_slug", this.generalConsultation.dossier.slug);
      this.$router.push({
        name: "edit-consultation-general",
        params: { consultation: this.consultation_id },
      });
    },

    deleteConsultation() {
      let self = this;
      let args = {
        consultation: this.consultation_id,
      };

      let successMessage = this.$i18n.t("message.generalConsultationDeleted");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };

      this.$store
        .dispatch("deleteGeneralConsultation", {
          args,
          index: self.consultation_id,
          successMessage,
          errorMessages,
        })
        .then(() => {
          self.$bvModal.hide("delete-modal");
          this.$router.back();
        });
    },

    archieveConsultation() {
      let self = this;
      let args = {
        consultation: this.consultation_id,
      };

      let successMessage = this.$i18n.t(
        "message.medecineConsultationArchieved"
      );
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };

      this.$store.dispatch("archieveMedecineConsultation", {
        args,
        index: self.consultation_id,
        successMessage,
        errorMessages,
      });
    },
    getVerification(c) {
      if (c === true) {
        return "Oui";
      } else {
        return "Non";
      }
    },

    transmitConsultation() {
      let self = this;
      let args = {
        consultation: this.consultation_id,
      };

      let successMessage = this.$i18n.t(
        "message.medecineConsultationTransmitted"
      );
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };

      this.$store.dispatch("transmitMedecineConsultation", {
        args,
        index: self.consultation_id,
        successMessage,
        errorMessages,
      });
    },

    reactiveConsultation() {
      let self = this;
      let args = {
        consultation: this.consultation_id,
      };

      let successMessage = this.$i18n.t(
        "message.medecineConsultationReactived"
      );
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };

      this.$store.dispatch("reactiveMedecineConsultation", {
        args,
        index: self.consultation_id,
        successMessage,
        errorMessages,
      });
    },

    isArchived: function(date) {
      let momentDate = moment(date);
      return !momentDate.isValid();
    },

    isTransmitted: function(date) {
      var momentDate = moment(date);
      return !momentDate.isValid();
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return "";
      }
    },
    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },
    clearErrorField(field) {
      this.$store.dispatch("clearErrorField", { field });
      this.getErrorsField(field);
    },
    pathHas(element) {
      let result = this.$route.fullPath.includes(element);
      if (result) {
        if ($("#" + element).length) {
          document.getElementById(element).scrollIntoView(top);
        }
      }

      return result;
    },
    getTranslate(c) {
      let glycated = this.$i18n.t("message.glycated");
      let glycemie = this.$i18n.t("message.glycemie");
      let cholestorol = this.$i18n.t("message.cholestorol");
      let hdl = this.$i18n.t("message.hdl");
      let ldl = this.$i18n.t("message.ldl");
      let tags = this.$i18n.t("message.tags");
      let malnutrition = this.$i18n.t("message.malnutrition");
      let deshydradation = this.$i18n.t("message.deshydradation");
      if (c === "glycated") {
        return glycated;
      }
      if (c === "glycemie") {
        return glycemie;
      }
      if (c === "cholestorol") {
        return cholestorol;
      }
      if (c === "hdl") {
        return hdl;
      }
      if (c === "ldl") {
        return ldl;
      }
      if (c === "tags") {
        return tags;
      }
      if (c === "malnutrition") {
        return malnutrition;
      }
      if (c === "deshydratation") {
        return deshydradation;
      }
    },
  },
  created() {
    this.handleView();
    window.addEventListener('resize', this.handleView);
  },
  watch:{
      exams_validate: function(value){
        let self = this;
        let somme = 0;
        _.forEach(value,function(data){
            // console.log(data)
            somme += data.prix;
         }) 
        self.prixTotal = somme;
      }
  },
  mounted() {
    this.getConsultation();
    this.examenComplementaire();
  },
};
</script>

<style scoped></style>